/* React */
import React from "react";

/* Utils */
import { kaplanMeierFormula } from "src/utils/helper/survival-analysis/kaplanMeierFormula";

/* Stylesheet */
import styles from "./ContentContainer.module.scss";

const ContentContainer: React.FC = () => {
  return (
    <>
      <h6>Kaplan-Meier Curve</h6>
      <p>
        The Kaplan-Meier estimator is a non-parametric
        statistic used to estimate the survival function
        from time-to-event data. It provides a step function
        that represents the probability of an event (e.g.
        survival) over time.
      </p>
      <p className={styles.formula}>
        {kaplanMeierFormula()}
      </p>
      <p>
        The curve decreases at each event time and remains
        flat between events. Censored data (e.g. lost to
        follow-up) are accounted for by reducing the number
        at risk without affecting the probability.
      </p>
    </>
  );
};

export default ContentContainer;
